import { inject, Injectable } from '@angular/core';
import { DemoType } from '@app/+onboarding/components/demo-dialog/demo-dialog.model';
import { DemoDialogService } from '@app/+onboarding/components/demo-dialog/demo-dialog.service';
import { SbDialogService } from '@sb/ui/dialog';

import { AbsenceManagementDialogComponent } from '../absence-management/absence-management-dialog.component';
import { AbsenceManagementDialogStep } from '../absence-management/absence-management.model';
import { AbsenceManagementDialogData } from './../absence-management/absence-management.model';

@Injectable({
  providedIn: 'root',
})
export class AbsenceManagementOnboardingService {
  private dialogService = inject(SbDialogService);
  private demoDialogService = inject(DemoDialogService);

  openDialog(originator = 'onboarding', step?: AbsenceManagementDialogStep) {
    return this.dialogService
      .setSize('xxl')
      .open<AbsenceManagementDialogComponent, AbsenceManagementDialogData>(AbsenceManagementDialogComponent, {
        data: {
          eventData: { originator },
          step,
        },
      }).closed;
  }

  openDemo() {
    return this.demoDialogService.openDemo(DemoType.ABSENCE_MANAGEMENT);
  }
}
